import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { arrowbg, clients, workright } from '../../../assets/images';
import { blogApi } from '../../../apiService/blogApis';

const PopularArticles = () => {
    const [articles, setArticles] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        blogApi.getBlogs({ page: 1, limit: 6, status: 'published' })
            .then(response => setArticles(response.data || []))
            .catch(() => setArticles([]));
    }, []);

    const calculateReadingTime = (content) => {
        if (!content) return null;
        const words = content.replace(/<[^>]*>/g, '').trim().split(/\s+/).length;
        return Math.ceil(words / 225);
    };

    return (
        <div className="position-relative d-md-block d-none">
            <div className='container mb-5'>
                <div className='row gap-4'>
                    <div className="col-12 d-flex flex-column align-items-center justify-content-start mt-md-4 mb-md-2 mb-5">
                        <h2 className="mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold">Our Most Popular Aricles</h2>
                        <p className="mb-0 text-dark add_para_font fw-medium text-center">Our mental health billing experts deliver complete revenue cycle management services — from system  <br />integration to strategic practice consulting.</p>
                    </div>

                    {articles.slice(0, 2).map((article) => (
                        <div
                            key={article._id}
                            className='col px-0 mb-4 add_box_shadow'
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate(`/blog/${article.slug || article._id}`)}
                        >
                            <div className='row mx-auto'>
                                <div className='col'>
                                    <div className='row'>
                                        <div className='col-12 px-0'>
                                            <img
                                                src={article?.coverImage?.url || require('../../../assets/flatlayImg.webp')}
                                                alt={article.title}
                                                style={{ width: '100%', objectFit: 'cover' }}
                                            />
                                        </div>
                                        <div className='col-12 py-4 px-4'>
                                            <div className='row'>
                                                <div className='col-6 text-start'>
                                                    {new Date(article.createdAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                                                </div>
                                                <div className='col-6 text-end'>
                                                    {calculateReadingTime(article.content) ? `${calculateReadingTime(article.content)} min read` : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 text-start mb-md-3 px-4">
                                            <h3 className="add_top_heading_content mb-0 ms-md-0 ms-0 fw-semibold">{article.title}</h3>
                                        </div>
                                        <div className="col-12 text-start px-4">
                                            <p className="mb-0 add_font_card_para_data">
                                                {article.excerpt?.length > 150 ? article.excerpt.slice(0, 149) + '...' : article.excerpt}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className='col px-0 mb-4 newsletter-card'>
                        <div className='row mx-auto px-3 py-4'>
                            <div className='col'>
                                <div className="newsletter-icon"><img src={arrowbg} alt='' style={{ height: "6rem" }} /></div>
                                <h2 className='add_subfont my-4'>Get the Latest RCM News Delivered</h2>
                                <p className='mb-4'>Receive practical tips on medical billing and breaking news on RCM in your inbox.</p>
                                <input type="email" placeholder="Enter Your Email" className="email-input w-100 border-0 mb-4" />
                                <div className="col-md-12">
                                    <button
                                        type="submit"
                                        className="btn col-12"
                                        style={{
                                            background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                            color: "white",
                                            borderRadius: "12px",
                                            padding: "12px 20px",
                                            border: "none",
                                            fontWeight: "500",
                                            fontSize: "16px"
                                        }}
                                    >
                                        Subscribe
                                    </button>
                                </div>
                                <p className="privacy-text text-start">
                                    Read about our <Link to={"/privacy-policy"}>Privacy Policy</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="boost_main_client boost_main_client_tranform_first position-absolute"><img src={clients} alt="" /></div>
            <div className="boost_main_client_right boost_main_client_right_tranform_second position-absolute"><img src={workright} alt="" /></div>
        </div>
    );
};

export default PopularArticles;
